export default () => {
  document.querySelectorAll('.pathways__filter').forEach((filterEl) => {
    const dropdown = filterEl.querySelector('.pathways__filter__dropdown');
    const header = dropdown.querySelector('.pathways__filter__dropdown__header');
    const optionsWrapper = dropdown.querySelector('.pathways__filter__dropdown__options');
    const options = dropdown.querySelectorAll('.pathways__filter__dropdown__option');
    const hiddenSelect = filterEl.querySelector('select[data-filter]');

    dropdown.addEventListener('click', (e) => {
      if (e.target.closest('.pathways__filter__dropdown__option')) return;
      optionsWrapper.classList.toggle('open');
    });

    options.forEach((option) => {
      option.addEventListener('click', () => {
        const value = option.dataset.value;
        const alreadySelected = dropdown.dataset.selected === value && value !== '';
        const newValue = alreadySelected ? '' : value;

        dropdown.dataset.selected = newValue;

        options.forEach(opt => opt.classList.remove('selected'));
        if (!alreadySelected) option.classList.add('selected');

        header.textContent = newValue ? option.textContent : 'Select from list';
        optionsWrapper.classList.remove('open');

        if (hiddenSelect) {
          hiddenSelect.value = newValue;
          hiddenSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  });

  document.addEventListener('click', (e) => {
    document.querySelectorAll('.pathways__filter__dropdown__options.open').forEach((optionsWrapper) => {
      if (!optionsWrapper.closest('.pathways__filter__dropdown').contains(e.target)) {
        optionsWrapper.classList.remove('open');
      }
    });
  });

  document.querySelectorAll('.pathways__filter-wrapper').forEach((filterWrapper) => {
    const container = filterWrapper.closest('.pathways__container');
    if (!container) {
      return;
    }

    const itemsWrapper = container.querySelector('.pathways__wrapper');
    if (!itemsWrapper) {
      return;
    }

    const items = Array.from(itemsWrapper.querySelectorAll('.pathways__item'));
    const selects = filterWrapper.querySelectorAll('select[data-filter]');
    const emptyMessage = container.querySelector('.pathways__empty');

    const applyFilters = () => {
      const activeFilters = {};
      selects.forEach((select) => {
        if (select.value) {
          activeFilters[select.dataset.filter] = select.value;
        }
      });

      let visibleCount = 0;
      items.forEach((item) => {
        const matches = Object.keys(activeFilters).every((key) => {
          const values = (item.dataset[key] || '').split(',').filter(Boolean);
          return values.includes(activeFilters[key]);
        });
        item.style.display = matches ? '' : 'none';
        if (matches) {
          visibleCount++;
        }
      });

      if (emptyMessage) {
        emptyMessage.style.display = visibleCount === 0 ? '' : 'none';
      }
    };

    selects.forEach((select) => {
      select.addEventListener('change', applyFilters);
    });
  });
}
